import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { marginProps } from './props';

const CustomIcon = styled.img`
  margin-top: -3px;
`;

// Size can have following values:
// xs: .75em
// sm: .875em
// lg: 1.33em Also applies vertical-align: -25%
// 2x: 2em
// 3x: 3em
// 4x: 4em
// 5x: 5em
// 6x: 6em
// 7x: 7em
// 8x: 8em
// 9x: 9em
// 10x: 10em
const Icon = ({
  type,
  className,
  onClick,
  light,
  size,
  disabled = false,
  solid = false,
  customIcon,
}) => {
  if (customIcon) {
    // eslint-disable-next-line
    const image = require(`../../assets/images/${type}_1x.png`);
    return <CustomIcon src={image.default} alt='' />;
  }
  return (
    <i
      // eslint-disable-next-line
      className={`${className} ${light ? 'far' : solid ? 'fas' : 'fa'} fa-${type}${size ? ` fa-${size}` : ''}`}
      onClick={onClick}
      disabled={disabled}
    />
  );
};
Icon.propTypes = {
  size: PropTypes.string,
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string.isRequired,
  light: PropTypes.bool,
  disabled: PropTypes.bool,
  solid: PropTypes.bool,
  customIcon: PropTypes.bool,
};

export default styled(Icon)`
  ${marginProps};
  cursor: ${p => p.onClick ? 'pointer' : 'default'};
  ${p => p.fontSize && `font-size: ${p.fontSize}px`};
  color: ${p => p.theme === 'light' ? '#fff' : '#0098cc'};
  ${p => p.disabled && `
    opacity: 0.6;
    cursor: not-allowed;
  `}
`;
